module.exports = __webpack_public_path__ + "static/media/times-solid.b3d50713.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/icons/times-solid.svg
// module id = 279
// module chunks = 2